import React, { Component } from 'react';
import { Header, Grid, Icon, Form, Button, Segment, Dropdown } from 'semantic-ui-react';
import { getPaymentsSubmissionInfo, exportXLSX } from '../../utils/rest';
import BreadcrumbCustom from '../../layout/BreadcrumbCustom';
import ReactTable from 'react-table';
import { adjustmentStatus, paymentStatus } from '../../utils/defaults';
import MessageBox from '../../ui/MessageBox';
import Loading from '../Loading';

const initialState = {
    conFirstName: "",
    conLastName: "",
    from: "",
    to: "",
    acxInvoiceId: "",
    acxAccountId: "",
    pmtStatus: "",
    adjStatus: "",
}
class PaymentAdjustmentSubmission extends Component {
    constructor(props) {
        super(props);
        this.state = {
            payments: [],
            initialState,
            loading: false
        };
    }

    componentDidMount() {
        this.props.addItem("helpFile", "pmt_view-payment-adjustment-submissions.md");
    }

    componentWillUnmount() {
        this.props.addItem("helpFile", null);
    }

    handleChange = (e) => {
        this.setState({
            initialState: {
                ...this.state.initialState,
                [e.target.name]: e.target.value
            }
        });
    }

    handleChangeSelect = (evt, e) => {
        this.setState({
            initialState: {
                ...this.state.initialState,
                [e.name]: e.value
            }
        });
    }

    handleSubmit = (e) => {
        e.preventDefault();
        if (this.checkEmpty(this.state.initialState)) {
            this.setState({
                loading: true
            }, () => {
                getPaymentsSubmissionInfo(this.props.items.currentCorporate, this.state.initialState).then((response) => {
                    if (response !== null && response instanceof Array) {
                        this.setState({
                            payments: response,
                            loading: false
                        })
                    }
                }).then(() => {
                    this.setState({
                        loading: false
                    });
                })
            });
        } else {
            this.setState({
                errorOpen: true,
                loading: false
            })
        }
    }

    checkEmpty = (searchIndex) => {
        let r = false;
        for (let search in searchIndex) {
            if (searchIndex[search].length > 0) {
                r = true;
                break;
            }
        }
        return r;
    }
    reset = () => {
        this.setState({
            ...this.state.initialState,
            initialState
        })
    }



    close = () => {
        this.setState((prevState, props) => {
            return { errorOpen: false };
        });
    }

    render() {
        return (
            <div>
                {(this.state.loading) ? <Loading /> : ""}
                <BreadcrumbCustom {...this.props} parent="Payments" child={[{ name: "View Payment & Adjustment Submissions", url: null }]} />
                <Grid className="g-bkgd">
                    <Grid.Row>
                        <Grid.Column>
                            <Form className="small">
                                <Form.Group>
                                    <Form.Input width={3} label={this.props.t("client.account")+":"} placeholder={this.props.t("client.account")} name="acxInvoiceId" value={this.state.initialState.acxInvoiceId} onChange={this.handleChange} />
                                    <Form.Input width={3} label={this.props.t("our.account")+":"} placeholder={this.props.t("our.account")} name="acxAccountId" value={this.state.initialState.acxAccountId} onChange={this.handleChange} />
                                    <Form.Input width={3} label='Start Date:' placeholder='mm / dd / yyyy' type="date" name="from" value={this.state.initialState.from} onChange={this.handleChange} />
                                    <Form.Input width={3} label='End Date:' placeholder='mm / dd / yyyy' type="date" name="to" value={this.state.initialState.to} onChange={this.handleChange} />
                                </Form.Group>
                                <Form.Group>
                                    <Form.Field width={3}>
                                        <Form.Input label='First Name:' placeholder='First Name' name="conFirstName" value={this.state.initialState.conFirstName} onChange={this.handleChange} />
                                    </Form.Field>
                                    <Form.Field width={3}>
                                        <Form.Input label='Last Name:' placeholder='Last Name' name="conLastName" value={this.state.initialState.conLastName} onChange={this.handleChange} />
                                    </Form.Field>
                                    <Form.Field width={3}>
                                        <label>Payment Status:</label>
                                        <Dropdown placeholder='Select' selection options={paymentStatus} name="pmtStatus" value={this.state.initialState.pmtStatus} onChange={this.handleChangeSelect} />
                                    </Form.Field>
                                    <Form.Field width={3}>
                                        <label>Adjustment Status:</label>
                                        <Dropdown placeholder='Select' className="fluid" selection options={adjustmentStatus} name="adjStatus" value={this.state.initialState.adjStatus} onChange={this.handleChangeSelect} />
                                    </Form.Field>
                                    <Form.Field width={4}>
                                        <Button.Group width={4} className="small buttons push-down">
                                            <Button onClick={this.reset}>{this.props.t("reset")}</Button>
                                            <Button.Or />
                                            <Button positive onClick={this.handleSubmit}>{this.props.t("submit")}</Button>
                                        </Button.Group>
                                    </Form.Field>
                                </Form.Group>
                            </Form>
                            <Segment.Group>
                                <Segment raised color="grey" inverted>
                                    <Header as="h4">
                                        <div className="content">
                                            Payment & Adjustment Submissions
                                        </div>
                                    </Header>
                                </Segment>
                                <Grid className="margin-bottom-5">
                                    <Grid.Column width={1} floated='right' className="remvespace-btm">
                                        <Button onClick={() => {
                                            exportXLSX(
                                                {
                                                    "Client ID": "cltClientId",
                                                    "Consumer's Last Name": "conLastName",
                                                    "Consumer's First Name": "conFirstName",
                                                    "Client Acct#": "acxInvoiceId",
                                                    "Our Acct#": "acxAccountId",
                                                    "Currency Code": "currencyCode",
                                                    "Date Of Submission": "pmtDateOfSubmission",
                                                    "Payment": "payment",
                                                    "Payment Date": "pmtDate",
                                                    "Adjustment": "adjustment",
                                                    "Adjustment Date": "adjDate",
                                                    "Status": "pmtAdjStatus"


                                                }, this.state.payments, "PaymentSubmissions.xlsx")
                                        }}
                                            className="ui left small icon button icon-export" data-inverted="" data-tooltip="Export Table Details to Spreadsheet" data-position="bottom right">
                                            <i className="file excel icon"></i>
                                        </Button>
                                    </Grid.Column>
                                </Grid>
                                {/*<Grid className="grid-bottom">
                                    <Grid.Column width={4}>
                                        <p className="row-select">[Row Select Here]</p>
                                    </Grid.Column>
                                    <Grid.Column width={11}>
                                        <div className="ui right floated icon small search input search-ph">
                                            <Icon name="search" />
                                            <input placeholder="Search Table Results" type="text" />
                                        </div>
                                    </Grid.Column>
                                    <Grid.Column width={1}>
                                        <Button className="ui left small icon button icon-export" data-inverted="" data-tooltip="Export Table Details to Spreadsheet" data-position="bottom left">
                                            <Icon name="file excel" />
                                        </Button>
                                    </Grid.Column>
                                </Grid> */}
                                <ReactTable noDataText={null} minRows={0} defaultPageSize={this.props.reactTable().pageSize} showPagination={this.state.payments && this.state.payments.length > this.props.reactTable().pageSize ? true : false} filterable defaultFilterMethod={this.props._customFilter} className="celled -striped -highlight "
                                    data={this.state.payments}
                                    getNoDataProps={() => {
                                        return { style: { display: 'none' } };
                                    }}
                                    columns={[{
                                        Header: props => <span data-inverted="" data-tooltip="Our Client Identifier" data-position="bottom left">Client ID</span>,
                                        accessor: 'cltClientId',
                                        maxWidth: 130
                                    }, {
                                        Header: props => <span data-inverted="" data-tooltip="Consumer’s First & Last Name" data-position="bottom left">{this.props.t("consumer.name")}</span>,
                                        id: 'conFirstName',
                                        accessor: row => (
                                            row.conLastName + " " + row.conFirstName
                                        )
                                    }, {
                                        Header: props => <span data-inverted="" data-tooltip="Your Account Number for this Billing" data-position="bottom left">Client Acct#</span>,
                                        accessor: 'acxInvoiceId',
                                        maxWidth: 130
                                    }, {
                                        Header: props => <span data-inverted="" data-tooltip="Our Agency’s Account Number" data-position="bottom left">Our Acct#</span>,
                                        accessor: 'acxAccountId',
                                        maxWidth: 130
                                    },{
                                        Header: props => <span data-inverted="" data-tooltip="Account Currency Code" data-position="bottom left">Currency Code</span>,
                                        accessor: 'currencyCode',
                                        maxWidth: 130
                                    }, {
                                        Header: props => <span data-inverted="" data-tooltip="Date Payment and/or Adjustment Submitted." data-position="bottom left">Date Of Submission</span>,
                                        id: 'pmtDateOfSubmission',
                                        accessor: row => (
                                            this.props._formatDate(row.pmtDateOfSubmission)
                                        ),
                                        maxWidth: 130
                                    }, {
                                        Header: props => <span data-inverted="" data-tooltip="Payment Amount" data-position="bottom left">Payment</span>,
                                        id: 'payment',
                                        style: {
                                            textAlign: "right"
                                        },
                                        accessor: row => (
                                            this.props._currencyFormat(row.payment)
                                        ),
                                        maxWidth: 100
                                    }, {
                                        Header: props => <span data-inverted="" data-tooltip="Date Payment Made" data-position="bottom left">Pay Date</span>,
                                        id: 'pmtDate',
                                        accessor: row => (
                                            this.props._formatDate(row.pmtDate)
                                        ),
                                        maxWidth: 130
                                    }, {
                                        Header: props => <span data-inverted="" data-tooltip="Adjustment Amount" data-position="bottom left">Adjustment</span>,
                                        id: 'adjustment',
                                        style: {
                                            textAlign: "right"
                                        },
                                        accessor: row => (
                                            this.props._currencyFormat(row.adjustment)
                                        ),
                                        maxWidth: 100
                                    }, {
                                        Header: props => <span data-inverted="" data-tooltip="Date Adjustment Made" data-position="bottom left">Adj Date</span>,
                                        id: 'adjDate',
                                        accessor: row => (
                                            this.props._formatDate(row.adjDate)
                                        ),
                                        maxWidth: 130
                                    }, {
                                        Header: props => <span data-inverted="" data-tooltip="Is Payment Rejected/Approved/Pending" data-position="bottom right">Status</span>,
                                        accessor: 'pmtAdjStatus',
                                        width: 150
                                    }]}
                                />
                            </Segment.Group>
                        </Grid.Column>
                    </Grid.Row>
                </Grid>
                <MessageBox {...this.props} size="mini" box={9} open={this.state.errorOpen} close={this.close} />
            </div>
        );
    }
}
export default PaymentAdjustmentSubmission;


// WEBPACK FOOTER //
// ./src/app/ui/payments/PaymentAdjustmentSubmission.js